module.exports = __webpack_public_path__ + "static/img/13.e40e0e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/13.png
// module id = Pqrh
// module chunks = 0